/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'

const LEGACY_WRAPPER = 'legacy'

const FormSubscriptionFee = ({
  value = {},
  onChange = () => {},
  overlayContentRef,
  type,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {subscriptionMonthlyFees, DEFAULT_FILTER_VALUE, FILTER_NAMES} = config.get('search')

  const currentValue = {
    from: value.from || DEFAULT_FILTER_VALUE,
    to: value.to || DEFAULT_FILTER_VALUE
  }

  const localizePriceValue = priceValue => ({
    id: priceValue,
    label: i18n.n(priceValue)
  })
  const options = useMemo(() => subscriptionMonthlyFees.map(localizePriceValue), [])

  const selectOptions = {
    from: {
      name: FIELD_NAME.FROM,
      options
    },
    to: {
      name: FIELD_NAME.TO,
      options
    }
  }

  return (
    <SelectRange
      fieldName={FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE}
      label={i18n.t('COMMON.FEE_MONTHLY')}
      options={selectOptions}
      value={currentValue}
      onChange={onChange}
      overlayContentRef={overlayContentRef}
      type={type}
      withLabel={withLabel}
      wrapper={wrapper}
    />
  )
}

FormSubscriptionFee.displayName = 'FormSubscriptionFee'
FormSubscriptionFee.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const MemoFormSubscriptionFee = memo(FormSubscriptionFee)
MemoFormSubscriptionFee.displayName = 'FormSubscriptionFee'

export default MemoFormSubscriptionFee
